<template>
  <Component :is="component" />
</template>

<script lang="ts">
  import SingleArticle from '~/components/SingleArticle/SingleArticle.vue';
  import PageTemplate from '~/components/PageTemplate/PageTemplate.vue';
  import { usePageStore } from '~/store/pagesData';
  import { useArticleAnalyticsHead } from '~/domains/head/analytics/services/useArticleAnalyticsHead';
  import { useSeoHead } from '~/domains/head/seo/services/useSeoHead';
  import { useLastModifiedHead } from '~/domains/head/technical/services/useLastModifiedHead';

  export default defineNuxtComponent({
    name: 'ArticleNavigator',

    components: {
      SingleArticle,
      PageTemplate,
    },

    setup() {
      const pageStore = usePageStore();
      const seo = computed(() => pageStore.currentSeo!);

      useSeoHead(seo, {
        ampLink: Boolean(pageStore.currentArticle?.ampEnabled),
      });
      useArticleAnalyticsHead(pageStore.currentArticle, pageStore.currentSeo);
      useLastModifiedHead(pageStore.currentArticle?.lastModified);

      return {
        pageStore,
      };
    },

    computed: {
      isArticleTypePage() {
        return this.pageStore.isArticleTypePage;
      },
      component() {
        return this.isArticleTypePage ? PageTemplate : SingleArticle;
      },
    },
  });
</script>

<style lang="scss">
  .single-article {
    /* здесь находятся базовые стили, который используеются у ВСЕХ шаблонов страниц.
    Сами шаблоны находятся в components/singleArticle/ArticleTemplates
    */
    &__the-footer {
      margin: 0 16px;
      @include tablet {
        margin: 0;
      }
    }

    &__content-container {
      max-width: 100vw;
      padding: 0 16px;
      @include tablet {
        padding: 0 24px;
      }
    }

    .article-note {
      margin-bottom: 16px;
      padding: 0 16px;

      @include tablet {
        padding: 0;
      }

      @include big-tablet {
        padding: 0 24px;
      }
    }
  }
  .article__actions {
    margin: 0 16px;
    padding-bottom: 16px;

    @include tablet {
      margin: 0;
    }

    @include big-tablet {
      margin: 0 24px;
    }
  }

  .article-note {
    margin-top: 24px;
    &_empty {
      display: none;

      @include desktop {
        display: block;
      }
    }
  }
</style>
